import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n';
import i18n from './i18n';
import {useI18n} from 'vue-i18n';
import 'vuetify/styles';
import "@mdi/font/css/materialdesignicons.css";
import {styles} from "@/common-scripts/constants";


export default createVuetify({
	display: {
		mobileBreakpoint: 'md',
		thresholds: styles.thresholds
	},
	icons: {
		defaultSet: 'mdi',
		aliases,
		sets: {mdi}
	},
	theme: {
		defaultTheme: 'forexchange',
		themes: {
			forexchange: {
				dark: false,
				colors: {
					background: '#FFF',
					surface: '#FFF',
					primary: '#005FAB',
					accent: '#f27c00',
					'site-background': '#EFEFEF',
					'primary-darken-1': '#162450', 
					"on-background": '#444',
					'on-primary': '#FFFFFF',
					'on-surface': '#162450'
				}
			}
		}
	},
	locale: {
		adapter: createVueI18nAdapter({ i18n, useI18n })
	}
});
